import { Injectable, computed, signal } from '@angular/core';
import { APP_VERSION } from '../../environments/build-info';
import { environment } from '../../environments/environment';

@Injectable({
  providedIn: 'root',
})
export class AppBuildInfoService {
  readonly versionLabel = signal(`v.${APP_VERSION}`);
  readonly environmentLabel = signal(environment.environmentLabel);
  readonly showEnvironmentBadge = computed(() => this.environmentLabel() !== null);
}
